import defaultTheme from './defaultTheme';
const AdmiralTheme = {
  ...defaultTheme,
  Messages: {
    ...defaultTheme.Messages,
    HeaderTitleContainer: {
      ...defaultTheme.Messages.HeaderTitleContainer,
      height: '10%',
    },
  },
  BottomBar: {
    ...defaultTheme.BottomBar,
    Divider: {
      ...defaultTheme.BottomBar.Divider,
      width: 4,
    },
    BottomBarBackground: {
      ...defaultTheme.BottomBar.BottomBarBackground,
      height: '8rem',
      backgroundPosition: 'top',
    },
    BottomBarContainer: {
      ...defaultTheme.BottomBar.BottomBarContainer,
      maxWidth: '90%',
    },
    VIPIcon: {
      ...defaultTheme.BottomBar.VIPIcon,
      height: '9em',
    },
    BarItemIcon: {
      ...defaultTheme.BottomBar.BarItemIcon,
      height: '7em',
    },
    BarMissionsIcon: {
      height: '5.5em',
    },
    Notification: {
      ...defaultTheme.BottomBar.Notification,
      right: 40,
      top: 10,
    },
    MissionsIconAnimation: {
      ...defaultTheme.BottomBar.MissionsIconAnimation,
      height: '8.5em',
      bottom: 0,
      left: 35,
    },
    MissionsIconText: {
      ...defaultTheme.BottomBar.MissionsIconText,
      height: '1.3em',
    },
    MissionsIcon: {
      ...defaultTheme.BottomBar.MissionsIcon,
      height: '5.5em',
    },
  },
  DailySpin: {
    ...defaultTheme.DailySpin,
    MilestoneLoyaltyValue: {
      ...defaultTheme.DailySpin.MilestoneLoyaltyValue,
      marginLeft: -3,
    },
  },
  GameTile: {
    ...defaultTheme.GameTile,
    LivePanelItem: {
      ...defaultTheme.GameTile.LivePanelItem,
      height: '40%',
    },
  },
  Chest: {
    ...defaultTheme.Chest,
    ChestAnimation: {
      ...defaultTheme.Chest.ChestAnimation,
      height: 146.78,
      width: 155,
    },
    ChestAnimationEnd: {
      ...defaultTheme.Chest.ChestAnimationEnd,
      height: 166,
      width: 175,
    },
  },
};

export default AdmiralTheme;

